const int = {
  API_URL: 'https://back.rfc.dev.mka.canal.aws.cplus',
  OKTA_CLIENT_ID: '0oa2n01yi2obdtWLi417',
  OKTA_URL: 'https://mylogin.canal-plus.com/oauth2/aus397pnmkqUXnu8Y417',
  GROUP_TO_ROLES: {
    'grp-app-rfc-dev-dlg-fr': 'ROLE_FR',
    'grp-app-rfc-dev-dlg-int': 'ROLE_INT',
  },
};

const local = {
  API_URL: 'http://localhost:8080',
  OKTA_CLIENT_ID: '0oa3asjonawyhOWU90x7',
  OKTA_URL: 'https://groupecanalplustest.oktapreview.com/oauth2/aus3t6w9qf3iOFvtl0x7',
  GROUP_TO_ROLES: {
    'grp-app-rfc-dev-dlg-fr': 'ROLE_FR',
    'grp-app-rfc-dev-dlg-int': 'ROLE_INT',
  },
};

const rec = {
  API_URL: 'https://back.rfc.rec.canalplustech.pro',
  OKTA_CLIENT_ID: '0oa33plpe8HBd2Yyk417',
  OKTA_URL: 'https://mylogin.canal-plus.com/oauth2/aus397pnmkqUXnu8Y417',
  GROUP_TO_ROLES: {
    'grp-app-rfc-recette-dlg-fr': 'ROLE_FR',
    'grp-app-rfc-recette-dlg-int': 'ROLE_INT',
  },
};

const prod = {
  API_URL: 'https://back.rfc.prod.mka.canal.aws.cplus',
  OKTA_CLIENT_ID: '0oa33pm62aJDpA5C5417',
  OKTA_URL: 'https://mylogin.canal-plus.com/oauth2/aus397pnmkqUXnu8Y417',
  GROUP_TO_ROLES: {
    'grp-app-rfc-prod-dlg-fr': 'ROLE_FR',
    'grp-app-rfc-prod-dlg-int': 'ROLE_INT',
  },
};

const getConfiguration = () => {
  const env = window._env_?.REACT_APP_ENVIRONMENT;

  switch (env) {
    case 'prod':
      return prod;
    case 'local':
      return local;
    case 'rec':
      return rec;
    case 'int':
      return int;
  }
};

export default {
  NETWORK_TIME_OUT: 60000,
  ...getConfiguration(),
};
